<template>
    <div class="pagemain" v-html="contentPage">
        用稿协议
    </div>
  </template>
  
  <script>
  import axios from "axios";
  export default {
 
    data () {
      return {
        contentPage:'',
      }
    },
     //初始化方法
     mounted() {
      this.getmanuscrip();
      },
    methods: {
      //获取稿件的基本信息
      getmanuscrip() {
        axios.get(this.baseUrl.hbjx +'/contribution/loadTByPrimaryKey', {  //params参数必写 , 如果没有参数传{}也可以
          params: {
            id: this.$route.query.manuscriptId,
          }
        })
          .then((res)=> {
            this.contentPage = res.data.protocolContent
          })
          .catch(function (err) {
            console.log(err);
          });
      },
    }
  }
  </script>
  <style scoped>
 .pagemain{
   width: 1100px;
   height: auto;
 }
  </style>
  


// WEBPACK FOOTER //
// src/components/DraftAgreement/DraftAgreement.vue